var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrescentLogomark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1417,
    height: 296,
    viewBox: "0 0 1417 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.065 0.396023C173.425 0.380589 198.362 6.89193 220.473 19.3029C242.585 31.7139 261.127 49.6063 274.312 71.2568C264.114 71.1116 253.989 72.9937 244.526 76.7936C235.062 80.5935 226.449 86.2354 219.186 93.3914C211.923 100.547 206.156 109.075 202.219 118.478C198.283 127.881 196.256 137.973 196.256 148.166C196.256 158.359 198.283 168.45 202.219 177.853C206.156 187.257 211.923 195.784 219.186 202.94C226.449 210.096 235.062 215.738 244.526 219.538C253.989 223.338 264.114 225.22 274.312 225.075C260.882 247.1 241.919 265.229 219.306 277.659C196.694 290.089 171.22 296.387 145.417 295.928C119.614 295.469 94.3803 288.268 72.2249 275.041C50.0694 261.814 31.7635 243.023 19.127 220.534C6.4904 198.045 -0.0367247 172.642 0.194408 146.85C0.425542 121.059 7.40688 95.7765 20.4445 73.5174C33.482 51.2582 52.1217 32.7971 74.5107 19.9691C96.8997 7.14118 122.258 0.39322 148.065 0.396023Z",
    fill: "#FFC780"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.311 71.2102C264.114 71.065 253.989 72.947 244.525 76.7469C235.062 80.5468 226.448 86.1887 219.185 93.3448C211.922 100.501 206.155 109.028 202.219 118.431C198.282 127.835 196.255 137.926 196.255 148.119C196.255 158.312 198.282 168.404 202.219 177.807C206.155 187.21 211.922 195.737 219.185 202.893C226.448 210.05 235.062 215.691 244.525 219.491C253.989 223.291 264.114 225.173 274.311 225.028L273.859 225.777C258.831 239.396 240.167 248.356 220.137 251.566C200.108 254.776 179.576 252.098 161.042 243.857C142.508 235.616 126.77 222.168 115.744 205.151C104.718 188.133 98.8795 168.278 98.9389 148.004C98.9983 127.73 104.953 107.911 116.079 90.9576C127.204 74.0045 143.021 60.6493 161.603 52.5172C180.185 44.3852 200.732 41.827 220.742 45.1541C240.753 48.4812 259.364 57.5501 274.311 71.257V71.2102Z",
    fill: "url(#paint0_linear_1412_67831)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1412_67831",
    x1: 186.591,
    y1: 252.889,
    x2: 186.591,
    y2: 43.6775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964B48"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrescentLogomark);
export default __webpack_public_path__ + "static/media/crescent_logomark.b7e8cd155ad48e14b9a4098e89ea829a.svg";
export { ForwardRef as ReactComponent };